<template>
  <v-app-bar
    flat
    top
    class="header"
    :class="
      isLandscape
        ? `header--landscape px-8 ${tenantName}`
        : `header--portrait px-6 ${tenantName}`
    "
  >
    <v-col
      cols="12"
      class="header-content ma-0 pa-0 d-flex justify-space-between"
    >
      <div class="pa-0 ml-n1 d-flex flex-column justify-start">
        <p
          class="font-weight-bold t"
          :class="isLandscape ? 'text-h1-landscape mt-n5' : 'text-h2'"
        >
          {{ title }}
        </p>
        <p class="font-weight-bold text-h2 pt-3">
          {{ subtitle }}
        </p>
      </div>
      <div class="pa-0 d-flex justify-end date-text">
        <p :class="isLandscape ? 'text-h5 ' : 'text-body-1'">{{ date }}</p>
      </div>
    </v-col>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { Orientation } from "~/types/enum";
const { $dayjs } = useNuxtApp();
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
    default: null,
  },
  orientation: {
    type: String as PropType<Orientation>,
    required: true,
  },
});
const route = useRoute();
const now = ref($dayjs());
const title = computed(() => props.title);
const subtitle = computed(() => props.subtitle);
const date = computed(() => `${now.value.format("DD.MMMM YYYY, HH:mm")} Uhr`);
const orientation = computed(() => props?.orientation);
const isLandscape = computed(() => orientation.value === Orientation.landscape);
const lastReload = $dayjs().format("DD.MM.YYYY");
const tenantName = computed(() => {
  return route.params.tenant ?? "";
});

let interval: NodeJS.Timer;
onMounted(() => {
  interval = setInterval(() => {
    now.value = $dayjs();
    if (lastReload !== $dayjs().format("DD.MM.YYYY")) {
      window.location.reload();
    }
  }, 10000);
});
onUnmounted(() => {
  clearInterval(interval);
});
</script>

<style scoped lang="scss">
.header {
  /*  300 px of 1920 px */
  position: relative !important;
  width: 100vw;

  &--portrait {
    height: $header-height !important;

    &.uko-tower {
      height: 5vh !important;
      .date-text > p {
        padding: 30px;
        font-size: 2rem !important;
      }
    }
  }

  &--landscape {
    height: $header-height-landscape !important;

    &.uko-tower {
      .header-content {
        padding-left: 20px !important;
        padding-right: 20px !important;
      }

      .date-text {
        padding-top: 10px !important;
      }
    }
  }

  .header-content {
    height: 100%;
    width: 100%;
  }

  &.uko-tower {
    background-color: transparent;
  }
}
</style>

<style lang="scss">
.v-toolbar__content {
  height: $header-height !important;
}
</style>
